import {connect} from "react-redux";
import AttendanceMasterList from "./AttendanceMasterList";
import {bindActionCreators} from "redux";
import { getDaysData, allValetUsers, valetAttendanceRequest } from "services/redux/Valet/Supervisor/action";

const mapStateToProps = (state) => ({
    getAllTheDaysData: state.CreateSupervisor.getAllTheDaysData,
    // allValetUsersData: state.CreateSupervisor.allValetUsers,
    valetAttendanceRequest: state.CreateSupervisor.valetAttendanceRequest
    // getMonthsFilter: state.DarwinAttendanceSync.getMonthsFilter
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDaysData,
            // allValetUsers,
            valetAttendanceRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceMasterList);
